import NavigationCountIconRestructured from '@/components/routes/navigation/NavigationCountIconRestructured'
import { Tabs, Text } from '@/ui'
import { TypographyStyles } from '@/styles'
import { MESSAGE_TAB_META } from '../../lib/messageTabs'
import type { MessageTab, MessageThreadCounts } from '../../lib/types'

interface MessageTabsProps {
  /** null while a search is active: its results span every status, so no tab is in effect. */
  activeTab: MessageTab | null
  counts: MessageThreadCounts
  onSelect: (tab: MessageTab) => void
}

export const MessageTabs = ({
  activeTab,
  counts,
  onSelect,
}: MessageTabsProps) => {
  const handleValueChange = (value: string) => {
    const tab = MESSAGE_TAB_META.find(({ id }) => id === value)
    if (tab) onSelect(tab.id)
  }

  return (
    <Tabs value={activeTab ?? ''} onValueChange={handleValueChange}>
      <Tabs.List className="gap-1">
        {MESSAGE_TAB_META.map(({ id, label, countKey }) => {
          const count = countKey ? counts[countKey] : 0

          return (
            <Tabs.Trigger key={id} value={id} fullWidth className="gap-1">
              <Text variant={TypographyStyles.BODY_XS} className="text-inherit">
                {label}
              </Text>
              <NavigationCountIconRestructured count={count} />
            </Tabs.Trigger>
          )
        })}
      </Tabs.List>
    </Tabs>
  )
}
